module.exports = __webpack_public_path__ + "static/media/mac-filter.73593ecf.jpeg";